export default __webpack_public_path__ + "75d6d0a3c85b5c12b860b1ef6fac1cf8.png";